import React from 'react';
import './App.css';
import { MyCalendar } from './Components/MyCalendar';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <div className='app'>
      <h1>Vyberte termín a zvolte čas</h1>
      <MyCalendar />
      <a href={process.env.REACT_APP_WEB} type="button" className="btn btn-primary" style={{ marginTop: '60px' }}>Zpět na web</a>
    </div>
  );
}

export default App;
